import { AppDetails } from "src/types";

/**
 * Filters out built-in apps (like "Filter by Zapier", "Webhooks by Zapier", etc.)
 * from the apps list for display purposes.
 *
 * @param apps - Array of app slugs
 * @param appDetails - Map of app slug to AppDetails (must include isBuiltIn field)
 * @returns Filtered array of app slugs with built-in apps removed
 */
export const filterBuiltInApps = (
  apps: string[],
  appDetails: Map<string, AppDetails> | undefined,
): string[] => {
  if (!appDetails) {
    return apps;
  }

  return apps.filter((app) => {
    const details = appDetails.get(app);
    // If we don't have details for an app, keep it (don't filter it out)
    if (!details) {
      return true;
    }
    return !details.isBuiltIn;
  });
};
